
export default {
    props: {
        model: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    data() {
        return {
            email: {
                email: null,
                send_updates: false,
            },
            isSent: false,
        }
    },

    mounted() {
        if (this.$refs.emailForm) {
            this.$refs.emailForm.addEventListener('submit', (event) => {
                const isValid = this.$refs.emailForm.reportValidity()

                if (isValid) {
                    this.sendEmail()
                }

                event.preventDefault()
            })
        }
    },

    methods: {
        sendEmail() {
            // @TODO rsvp @bayi http://dev.wam/loverly-revamp/loverly-frontend/-/issues/689 "The last section are the settings which includes allowing guests to add plus ones and allowing guests to opt in to event updates via email."
            this.isSent = true
        },

        clear() {
            this.email = {
                email: null,
                send_updates: false,
            }
            this.isSent = false
        },
    },
}
